import { ExportButton } from '@/components/atoms/ExportButton/ExportButton';

import { useHumanAgentsExport } from '../../hooks/useHumanAgentsExport';

export const HumanAgentsExport = () => {
  const { exportAll, isAnyExportable, isExporting } = useHumanAgentsExport();

  if (!isAnyExportable) {
    return null;
  }

  return <ExportButton onExport={exportAll} isExporting={isExporting} />;
};
